module.exports = __webpack_public_path__ + "images/gold_kidney_b6ca10a.jpg";